// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"342":"efb79950","417":"85af9e81","652":"3a880272","965":"c620e131"}[chunkId] + ".css";
};